import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, MagazziniRdA, MagazzinoRdaModel, MagazzinoRdaViewModel } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class MagazziniRdAService extends CrudGenericsService<MagazziniRdA, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/MagazziniRdA`);
    this.base = `${env.apiUrl}/api/MagazziniRdA/`;
  }

  GetMagazzinoRdA_TableModel(date_min: string, date_max: string, nav_campo: string): Observable<MagazzinoRdaModel[]> {
    const u = `${this.base}GetMagazzinoRdA_TableModel?date_min=${date_min}&date_max=${date_max}&nav_campo=${nav_campo}`;
    return this.http.get<MagazzinoRdaModel[]>(u);
  }

  GetMagazzinoRdA_ViewModel(id: number): Observable<MagazzinoRdaViewModel> {
    const u = `${this.base}GetMagazzinoRdA_ViewModel?id=${id}`;
    return this.http.get<MagazzinoRdaViewModel>(u);
  }
}
